module.exports = __webpack_public_path__ + "static/media/ethereum-logo.f21b0526.png";